"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.PimSync.Hotfile.Api
 * API for Hotfile handling
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveDeactivateTypeToJSON = exports.ActiveDeactivateTypeFromJSONTyped = exports.ActiveDeactivateTypeFromJSON = exports.ActiveDeactivateType = void 0;
/**
 *
 * @export
 */
exports.ActiveDeactivateType = {
    Company: 0,
    Channel: 1,
    Category: 2,
    Assortment: 3,
    Theme: 4,
    Range: 5,
    Season: 6,
    Sustainability: 7,
    Feature: 8
};
function ActiveDeactivateTypeFromJSON(json) {
    return ActiveDeactivateTypeFromJSONTyped(json, false);
}
exports.ActiveDeactivateTypeFromJSON = ActiveDeactivateTypeFromJSON;
function ActiveDeactivateTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ActiveDeactivateTypeFromJSONTyped = ActiveDeactivateTypeFromJSONTyped;
function ActiveDeactivateTypeToJSON(value) {
    return value;
}
exports.ActiveDeactivateTypeToJSON = ActiveDeactivateTypeToJSON;
